// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__39PVt","rootSmall":"AddTileButton_rootSmall__1KRsf"};